<div class="inner-page-bg-right">
    <section class="hero-section">
        <div class="hero-container">

            <div class="hero-content">
                <p class="hero-tagline">Simple Pricing</p>
                <h1 class="hero-title">Powerful Outcomes</h1>

                <div class="hero-divider"></div>

                <p class="hero-description">
                    Start with what you need - and scale across locations, teams and campaigns with one connected
                    platform
                </p>


                <div class="hero-buttons">
                    <a href="#" class="btn-price">Start Free Trial</a>
                    <a href="#" class="btn-demo">Book a Live Demo</a>
                </div>

            </div>

            <div class="hero-media">
                <!-- <video
        class="hero-video"
        src="/assets/video/final-2 (animation).mp4"
        autoplay
        loop
        muted
        playsinline>
        Your browser does not support the video tag.
      </video> -->
                <img src="/assets/crm_images/Group 1324.png" alt="Pricing Hero Image" class="hero-image">
            </div>

        </div>
    </section>
    <section class="sf-landing-section">
        <div class="sf-container">

            <div class="sf-offer-wrapper">
                <h2 class="sf-heading">Limited Introductory Offer</h2>

                <div class="sf-price-toggle">
                    <div class="sf-toggle-panel sf-bg-green">
                        <span class="sf-toggle-title">1 Year Price Lock</span>
                        <span class="sf-toggle-desc">For qualified early adopters</span>
                    </div>
                    <div class="sf-toggle-panel sf-bg-dark">
                        <span class="sf-toggle-title">2 Year Price Lock</span>
                        <span class="sf-toggle-desc">Exclusive for NGOs</span>
                    </div>
                </div>
            </div>

            <div class="sf-features-wrapper">
                <h2 class="sf-heading">Trusted by Growing Businesses & Brands</h2>
                <p class="sf-subheading">Used by growing businesses, franchises, and brands to connect, engage, and
                    convert customers.</p>

                <div class="sf-features-grid">
                    <div class="sf-feature-card">
                        <div class="sf-icon-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                                <path
                                    d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                                <path d="m21 3 1 11h-2" />
                                <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                            </svg>
                        </div>
                        <div class="sf-card-content">
                            <h3 class="sf-card-title">Connect</h3>
                            <p class="sf-card-text">Instantly share contact details and capture leads at every
                                touchpoint.</p>
                        </div>
                    </div>

                    <div class="sf-feature-card">
                        <div class="sf-icon-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                            </svg>
                        </div>
                        <div class="sf-card-content">
                            <h3 class="sf-card-title">Engage</h3>
                            <p class="sf-card-text">Run smart promotions and campaigns that reach customers where they
                                are.</p>
                        </div>
                    </div>

                    <div class="sf-feature-card">
                        <div class="sf-icon-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="20" x2="18" y2="10"></line>
                                <line x1="12" y1="20" x2="12" y2="4"></line>
                                <line x1="6" y1="20" x2="6" y2="14"></line>
                                <line x1="2" y1="20" x2="22" y2="20"></line>
                            </svg>
                        </div>
                        <div class="sf-card-content">
                            <h3 class="sf-card-title">Convert</h3>
                            <p class="sf-card-text">Turn every scan and interaction into a qualified lead or sale.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sf-bottom-wrapper">
                <h2 class="sf-heading">Contact Share & Lead Capture</h2>
                <p class="sf-subheading">Capture every interaction and turn it into an opportunity. One QR code —
                    unlimited potential.</p>
            </div>

        </div>
    </section>


    <section class="vcard-pricing-module">

        <p class="alyro-state" *ngIf="isLoadingPlans">Loading pricing...</p>
        <p class="alyro-state" *ngIf="!isLoadingPlans && !hasAlyroPlans">Pricing is currently unavailable. Please check
            back soon.</p>

        <div class="alyro-wrapper" *ngIf="!isLoadingPlans && hasAlyroPlans">
            <div class="pricing-grid alyro-grid">
                <ng-container *ngFor="let plan of simplePlans">
                    <div *ngIf="plan.title !== 'ENTERPRISE'" class="pricing-card alyro-card"
                        [class.active]="activePlanId === plan.id" (click)="setActive(plan.id)">

                        <div class="alyro-card-head">
                            <h3 class="alyro-plan-name">{{ plan.title }}</h3>

                            <div class="alyro-billing" *ngIf="!plan.isFree" (click)="$event.stopPropagation()">
                                <div class="alyro-toggle">
                                    <button type="button" class="alyro-toggle-btn"
                                        [class.is-on]="alyroBilling === 'month'"
                                        [attr.aria-pressed]="alyroBilling === 'month'"
                                        (click)="setAlyroBilling('month')">Monthly</button>
                                    <button type="button" class="alyro-toggle-btn"
                                        [class.is-on]="alyroBilling === 'year'"
                                        [attr.aria-pressed]="alyroBilling === 'year'"
                                        (click)="setAlyroBilling('year')">Annual</button>
                                </div>
                                <span class="alyro-save-badge" *ngIf="getAlyroSavePercent(plan) > 0">Save {{
                                    getAlyroSavePercent(plan) }}%</span>
                            </div>
                        </div>

                        <div class="alyro-price">
                            <span class="alyro-price-amount">{{ getAlyroPrice(plan) }}</span>
                            <span class="alyro-price-period">/ month</span>
                        </div>
                        <p class="alyro-price-note">{{ getAlyroNote(plan) }}</p>

                        <div class="alyro-divider"></div>

                        <p class="alyro-tagline" *ngIf="plan.subtext">{{ plan.subtext }}</p>

                        <div class="alyro-team-size" *ngIf="plan.title === 'TEAM'" (click)="$event.stopPropagation()">
                            <p class="alyro-team-label">Select team size</p>
                            <div class="alyro-radio-group">
                                <label *ngFor="let num of userOptions" class="alyro-radio"
                                    [class.selected]="user === num">
                                    <input type="radio" name="alyroTeamSize" [value]="num" [checked]="user === num"
                                        (change)="selectUser(num)">
                                    <span class="alyro-radio-dot"></span>
                                    <span class="alyro-radio-text">{{ num }}</span>
                                </label>
                            </div>
                        </div>

                        <ul class="feature-list alyro-features">
                            <li *ngFor="let feature of plan.features">
                                <span class="alyro-check">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"
                                        stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                </span>
                                <span class="text">{{ feature }}</span>
                            </li>
                        </ul>

                        <button type="button" class="alyro-btn"
                            [ngClass]="activePlanId === plan.id ? 'btn-primary' : 'btn-outline'"
                            (click)="onClickGetStarted(plan, $event)">
                            {{ getAlyroBtnText(plan) }}
                        </button>
                    </div>
                </ng-container>
            </div>

            <div class="alyro-enterprise">
                <div class="alyro-enterprise-text">
                    <h3 class="alyro-enterprise-title">Enterprise Solutions</h3>
                    <p class="alyro-enterprise-sub">Need CRM integrations or a customized solution?</p>
                </div>
                <button type="button" class="alyro-enterprise-btn" (click)="onClickGetStarted(enterprisePlan, $event)">
                    {{ enterprisePlan.btnText }}
                </button>
            </div>
        </div>
    </section>

    <!-- [pricing-ui] Scanfluence Smart Site pricing cards (lower marked area) -->
    <section class="sf-pricing-wrapper">

        <div class="sf-pricing-main-card">
            <div class="sf-pricing-header">
                <span class="sf-pricing-tag">Essential Plans</span>
                <h2 class="sf-pricing-title">Start with Smart Site</h2>
                <p class="sf-pricing-desc">Start with a digital catalog. Add promotions and specials as you grow.</p>
            </div>

            <p class="sf-pricing-state" *ngIf="isLoadingPlans">Loading plans...</p>
            <p class="sf-pricing-state" *ngIf="!isLoadingPlans && !standardPlans.length">Plans are currently
                unavailable. Please check back soon.</p>

            <div class="sf-pricing-grid">
                <div *ngFor="let plan of standardPlans" class="sf-pricing-card"
                    [class.is-active]="activePlanId === plan.id" (click)="setActive(plan.id)">
                    <div class="sf-price-block">
                        <div class="sf-current-price">{{ formatPlanPrice(plan, 'current') }} <span>/month</span></div>
                        <div class="sf-sub-price">{{ formatPlanPrice(plan, 'yearlyPrice') }}/year<ng-container
                                *ngIf="getSavingsMonths(plan) > 0"> • Save up to {{ getSavingsMonths(plan) }} month{{
                                getSavingsMonths(plan) > 1 ? 's' : '' }}</ng-container></div>
                    </div>

                    <h3 class="sf-plan-name">{{plan.title}}</h3>

                    <ul class="sf-feature-list">
                        <li *ngFor="let feat of plan.features">
                            <span class="sf-check-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            {{feat}}
                        </li>
                        <li *ngIf="plan.footerNote" class="sf-footer-note">
                            {{plan.footerNote}}
                        </li>
                    </ul>

                    <button class="sf-pricing-btn" (click)="onClickGetStarted(plan, $event)">Get Started</button>
                </div>
            </div>
        </div>

        <!-- <p class="sf-pricing-footer">
            <strong>Need more stores?</strong> Both plans support additional store connections as a paid add-on — scale
            your locations anytime without switching plans.
        </p>

        <div class="sf-bottom-header">
            <h2>Which Plan Is Right for You?</h2>
            <p>Match your stage — scale when ready.</p>
        </div> -->
    </section>

    <section class="sf-pricing-wrapper">

        <div class="sf-pricing-main-card">
            <div class="sf-pricing-header">
                <span class="sf-pricing-tag">Multi-Location Plans</span>
                <h2 class="sf-pricing-title">Scale Across Locations</h2>
                <p class="sf-pricing-desc">Designed for multi-location operators and brands that need serious reach.</p>
            </div>

            <p class="sf-pricing-state" *ngIf="isLoadingPlans">Loading plans...</p>
            <p class="sf-pricing-state" *ngIf="!isLoadingPlans && !subscriptionPlans.length">Plans are currently
                unavailable. Please check back soon.</p>

            <div class="sf-pricing-grid">
                <div *ngFor="let plan of subscriptionPlans" class="sf-pricing-card"
                    [class.is-active]="activePlanId === plan.id" (click)="setActive(plan.id)">
                    <div class="sf-price-block">
                        <div class="sf-current-price">{{ formatPlanPrice(plan, 'current') }} <span>/month</span></div>
                        <div class="sf-sub-price">{{ formatPlanPrice(plan, 'yearlyPrice') }}/year<ng-container
                                *ngIf="getSavingsMonths(plan) > 0"> • Save up to {{ getSavingsMonths(plan) }} month{{
                                getSavingsMonths(plan) > 1 ? 's' : '' }}</ng-container></div>
                    </div>

                    <h3 class="sf-plan-name">{{plan.title}}</h3>

                    <ul class="sf-feature-list">
                        <li *ngFor="let feat of plan.features">
                            <span class="sf-check-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            {{feat}}
                        </li>
                    </ul>

                    <button class="sf-pricing-btn" (click)="onClickGetStarted(plan, $event)">Get Started</button>
                </div>
            </div>
        </div>

        <p class="sf-pricing-footer">
            <strong>Need more stores?</strong> Additional store connections are available as paid add-ons.
        </p>

        <div class="sf-bottom-header">
            <h2>Which Plan Is Right for You?</h2>
            <p>Match your stage — scale when ready.</p>
        </div>
    </section>


    <!-- <section class="sf-faq-section">
        <div class="sf-faq-curve-bg"></div>

        <div class="sf-faq-container">

            <header class="sf-faq-header">
                <h2 class="sf-faq-title">Frequently Asked Questions</h2>
                <p class="sf-faq-subtitle">Everything you need to know before you commit. No surprises — ever.</p>
            </header>

            <div class="sf-faq-card">
                <div *ngFor="let item of faqItems; let last = last" class="sf-faq-item" [class.active]="item.isOpen">

                    <div class="sf-faq-question" (click)="toggleItem(item)">
                        <span>{{ item.question }}</span>
                        <svg class="sf-faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="m6 9 6 6 6-6" />
                        </svg>
                    </div>

                    <div class="sf-faq-answer" [style.max-height]="item.isOpen ? '200px' : '0'">
                        <div class="sf-faq-answer-inner">
                            {{ item.answer }}
                        </div>
                    </div>

                    <hr *ngIf="!last" class="sf-faq-divider">
                </div>
            </div>

        </div>
    </section> -->
    <section class="sf-faq-section">
  <div class="sf-faq-curve-bg">
    <svg viewBox="0 0 1920 766" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <g filter="url(#filter0_i_863_809)">
        <path d="M0 722.799C0 722.799 584.56 766 960 766C1335.44 766 1920 722.799 1920 722.799V0C1920 0 1340.81 55.1912 960 55.1912C579.194 55.1912 0 0 0 0L0 722.799Z" fill="url(#paint0_linear_863_809)" fill-opacity="0.6"/>
      </g>
      <defs>
        <filter id="filter0_i_863_809" x="0" y="0" width="1920" height="768" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_863_809"/>
        </filter>
        <linearGradient id="paint0_linear_863_809" x1="959.499" y1="562.461" x2="959.499" y2="-16.7972" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F3FFFB"/>
          <stop offset="1" stop-color="#E0FAF1"/>
        </linearGradient>
      </defs>
    </svg>
  </div>

  <div class="sf-faq-container">
    <header class="sf-faq-header">
      <h2 class="sf-faq-title">Frequently Asked Questions</h2>
      <p class="sf-faq-subtitle">Everything you need to know before you commit. No surprises — ever.</p>
    </header>

    <div class="sf-faq-card">
      <div *ngFor="let item of faqItems; let last = last" class="sf-faq-item" [class.active]="item.isOpen">
        <div class="sf-faq-question" (click)="toggleItem(item)">
          <span>{{ item.question }}</span>
          <svg class="sf-faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </div>

        <div class="sf-faq-answer" [style.max-height]="item.isOpen ? '200px' : '0'">
          <div class="sf-faq-answer-inner">
            {{ item.answer }}
          </div>
        </div>
        <hr *ngIf="!last" class="sf-faq-divider">
      </div>
    </div>
  </div>
</section>

    <section class="sf-growth-section">
        <div class="sf-growth-container">

            <header class="sf-growth-header">
                <h2 class="sf-growth-title">Start Small. Scale Fast. Grow Smarter.</h2>
                <p class="sf-growth-subtitle">Choose the plan that fits your business today — and expand effortlessly as
                    you grow.</p>
            </header>

            <div class="sf-growth-content-grid">

                <div class="sf-growth-image-col">
                    <img src="assets/crm_images/Rectangle 99.png" alt="Scanfluence Scale Illustration"
                        class="sf-growth-main-img">
                </div>

                <div class="sf-growth-features-col">

                    <div class="sf-growth-card card-white">
                        <div class="sf-growth-icon-box box-purple">
                            <img src="/assets/crm_images/padlock (1) 1.png" alt="">
                        </div>
                        <div class="sf-growth-text">
                            <h3>Price Lock Guarantee</h3>
                            <p>Lock your rate early. No surprises.</p>
                        </div>
                    </div>

                    <div class="sf-growth-card card-green">
                        <div class="sf-growth-icon-box box-green-dark">
    <img src="/assets/crm_images/startup.png" alt="Startup Icon">
</div>
                        <div class="sf-growth-text">
                            <h3>Scale Without Limits</h3>
                            <p>Add stores, users, and campaigns anytime.</p>
                        </div>
                    </div>

                    <div class="sf-growth-card card-dark">
                        <div class="sf-growth-icon-box box-glass">
                            <img src="/assets/crm_images/target (1) 1.png" alt="">
                        </div>
                        <div class="sf-growth-text">
                            <h3>Risk-Free Start</h3>
                            <p>Free trial — no credit card required.</p>
                        </div>
                    </div>

                    <div class="sf-growth-actions">
                        <button class="sf-btn-outline">See How It Works</button>
                        <button class="sf-btn-solid">Start Your Campaign Today</button>
                    </div>

                </div>
            </div>
        </div>
    </section>


</div>

<!-- <section class="puzzle-section">
  <div class="puzzle-wrapper">
    
    <div class="puzzle-image-container">
       <img src="assets/crm_images/sdfdsfgfg 1.png" alt="3D Puzzle Pieces Integration" class="puzzle-image"> 
    </div>

    <div class="feature-item feature-tl">
      <div class="feature-card">
        <h3>Just Starting Out</h3>
        <p>Smart Site Lite</p>
      </div>
      <div class="svg-connector connector-tl">
        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="56" viewBox="0 0 232 56" fill="none">
          <path d="M6 48.25L52 6.25L231.5 0.25" stroke="url(#paint0_linear_tl)" stroke-width="0.5"/>
          <circle cx="5" cy="50.25" r="4.75" fill="#61BB9C" stroke="white" stroke-width="0.5"/>
          <defs>
            <linearGradient id="paint0_linear_tl" x1="6" y1="24.25" x2="278.5" y2="24.25" gradientUnits="userSpaceOnUse">
              <stop stop-color="#262261"/>
              <stop offset="1" stop-color="#8883CC"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>

    <div class="feature-item feature-bl">
      <div class="feature-card">
        <h3>Multiple Locations</h3>
        <p>Standard Plus</p>
      </div>
      <div class="svg-connector connector-bl">
        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="56" viewBox="0 0 232 56" fill="none">
          <path d="M6 48.25L52 6.25L231.5 0.25" stroke="url(#paint0_linear_bl)" stroke-width="0.5"/>
          <circle cx="5" cy="50.25" r="4.75" fill="#61BB9C" stroke="white" stroke-width="0.5"/>
          <defs>
            <linearGradient id="paint0_linear_bl" x1="6" y1="24.25" x2="278.5" y2="24.25" gradientUnits="userSpaceOnUse">
              <stop stop-color="#262261"/>
              <stop offset="1" stop-color="#8883CC"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>

    <div class="feature-item feature-tr">
      <div class="svg-connector connector-tr">
        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="56" viewBox="0 0 232 56" fill="none">
          <path d="M225.508 48.25L179.508 6.25L0.0078125 0.25" stroke="url(#paint0_linear_tr)" stroke-width="0.5"/>
          <circle cx="5" cy="5" r="4.75" transform="matrix(-1 0 0 1 231.508 45.25)" fill="#61BB9C" stroke="white" stroke-width="0.5"/>
          <defs>
            <linearGradient id="paint0_linear_tr" x1="225.508" y1="24.25" x2="-46.9922" y2="24.25" gradientUnits="userSpaceOnUse">
              <stop stop-color="#262261"/>
              <stop offset="1" stop-color="#8883CC"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="feature-card">
        <h3>Running Campaigns</h3>
        <p>Standard</p>
      </div>
    </div>

    <div class="feature-item feature-br">
      <div class="svg-connector connector-br">
        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="56" viewBox="0 0 232 56" fill="none">
          <path d="M225.508 48.25L179.508 6.25L0.0078125 0.25" stroke="url(#paint0_linear_br)" stroke-width="0.5"/>
          <circle cx="5" cy="5" r="4.75" transform="matrix(-1 0 0 1 231.508 45.25)" fill="#61BB9C" stroke="white" stroke-width="0.5"/>
          <defs>
            <linearGradient id="paint0_linear_br" x1="225.508" y1="24.25" x2="-46.9922" y2="24.25" gradientUnits="userSpaceOnUse">
              <stop stop-color="#262261"/>
              <stop offset="1" stop-color="#8883CC"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="feature-card">
        <h3>Need Integrations</h3>
        <p>Standard Omni</p>
      </div>
    </div>

  </div>
</section> -->

<section class="sf-footer-wrapper">
    <div class="sf-top-wave">
        
    </div>

    <div class="sf-main-container">
        <div class="sf-content-card">
            <div class="sf-grid-layout">

                <div class="sf-col sf-brand-block">
                    <img src="/assets/crm_images/logo-main.png" alt="Scanfluence" class="sf-brand-logo">
                    <p class="sf-hero-text">Connected QR Platform</p>
                    <div class="sf-description">
                        <p>From Contact to Conversion</p>
                        <p>Powered by One Connected QR System</p>
                    </div>
                    <div class="sf-social-links">
                        <a href="#"><i class="fab fa-facebook-f"></i></a>
                        <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        <a href="#"><i class="fab fa-youtube"></i></a>
                        <a href="#"><i class="fab fa-twitter"></i></a>
                    </div>
                </div>

                <div class="sf-col sf-bordered-col">
                    <h3 class="sf-col-header">PRODUCTS</h3>
                    <ul class="sf-list">
                        <li><a href="#">V Card</a></li>
                        <li><a href="#">Product QR</a></li>
                        <li><a href="#">Smart Site</a></li>
                        <li><a href="#">Smart Promo</a></li>
                        <li><a href="#">Smart Gift</a></li>
                    </ul>
                </div>

                <div class="sf-col sf-bordered-col">
                    <h3 class="sf-col-header">SOLUTIONS</h3>
                    <ul class="sf-list">
                        <li><a href="#">Retail & Franchise</a></li>
                        <li><a href="#">Brands & CPG</a></li>
                        <li><a href="#">Service Businesses</a></li>
                        <li><a href="#">Sales Teams (B2B)</a></li>
                        <li><a href="#">Malls & Multi-location</a></li>
                    </ul>
                </div>

                <div class="sf-col sf-bordered-col">
                    <h3 class="sf-col-header">PLATFORM</h3>
                    <ul class="sf-list">
                        <li><a href="#">Integrations</a></li>
                        <li><a href="#">Pricing</a></li>
                        <li><a href="#">Book a Demo</a></li>
                        <li><a href="#">Sign In</a></li>
                    </ul>
                </div>

                <div class="sf-col sf-bordered-col">
                    <h3 class="sf-col-header">COMPANY</h3>
                    <div class="sf-contact-details">
                        <p>Phone: +1 (437) 826 SCAN</p>
                        <p>Fax: +1 (437) 253 1432</p>
                        <p>Email: Hello@scanfluence.com</p>
                        <p>Address: 3600 Steeles Avenue East Markham, ON, L3R 9Z7</p>
                    </div>
                </div>

            </div>
        </div>

        <div class="sf-bottom-bar">
            <div class="sf-copyright">
                © 2026 Scanfluence | <a href="#">Privacy</a> | <a href="#">Terms</a>
            </div>
            <div class="sf-footer-nav">
                <a href="#">About Us</a> | <a href="#">Contact Us</a>
            </div>
        </div>
    </div>
</section>